import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { LocaleModule } from 'common/locale'

import { ElementsClientNotRunningModalComponent } from './components/elementsClientNotRunningModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocaleModule.forChild(),
    ElementsClientNotRunningModalComponent,
  ],
})
export class UtilElementsClientModule { }

export { ElementsClientService } from './services/elementsClient.service'
